import React from 'react'
import CheckOutImg from 'assets/images/birthday-and-party.svg'
import Rocket from 'assets/Rocket.svg'
const CheckOutHeader = ({planName2Price,planName2GST}) => {
    return (
        <div className="checkoutHeadDiv">
            <img src={CheckOutImg} alt="" className="headImg" />
            <div className="gx-d-flex gx-flex-row gx-align-items-center gx-justify-content-between gx-h-100 gx-px-4">
                <img src={Rocket} alt="Rocket"/>
                <div>
                    <h4 style={{color : 'white'}} className="gx-font-sans-regular">Order Summary</h4>
                    <p style={{color : 'white'}}  className="gx-mb-0 gx-font-sans-regular">premium membership</p>
                </div>
                <div>
                    <h2 style={{color : 'white'}} className="gx-mb-0 gx-font-sans-bold">${+planName2Price + +planName2GST}</h2>
                </div>
            </div>
        </div>
    )
}

export default CheckOutHeader
